import { z } from "zod";

export const ownerSchema = z.object({
  id: z.number(),
  full_name: z.string(),
});
